import Drawer from '@mui/material/Drawer';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

export const BOTTOM_NAV_HEIGHT = 250;

const StyledDrawer = styled(Drawer, {
  shouldForwardProp: prop => prop !== 'open',
})<{ open: boolean; width: number }>(({ theme, open, width }) => ({
  position: 'relative',
  zIndex: 1200,
  width,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: open ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen / 2,
  }),
  overflowX: open ? 'visible' : 'hidden',
  '& .MuiDrawer-paper': {
    width,
    overflowX: open ? 'visible' : 'hidden',
    backgroundColor: theme.palette.primary.main,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: open ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen / 2,
    }),
  },
}));

const DrawerContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: 0,
  position: 'relative',
});

const DrawerTop = styled('div')({});

const DrawerBottom = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flexGrow: 1,
});

const LogoContainer = styled(Paper)(({ theme }) => ({
  display: 'flex',
  minHeight: `${theme.toolbarHeight}px`,
  alignItems: 'center',
  justifyContent: 'center',
}));

const BottomGradient = styled('div')(({ theme }) => ({
  background: `linear-gradient(0deg, ${theme.palette.primary.dark} -50%, ${theme.palette.primary.main} 100%)`,
  zIndex: 1000,
  maxHeight: BOTTOM_NAV_HEIGHT,
}));

const ToggleButton = styled('button')({
  position: 'fixed',
  bottom: '20px',
  left: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  width: '40px',
  height: '40px',
});

const ButtonReset = styled('div')({
  background: 'none',
  border: 'none',
  padding: 0,
  margin: 0,
  font: 'inherit',
  textAlign: 'inherit',
  width: '100%',
});

export {
  StyledDrawer,
  DrawerContainer,
  DrawerTop,
  DrawerBottom,
  LogoContainer,
  BottomGradient,
  ToggleButton,
  ButtonReset,
};
// import { createStyles, makeStyles } from '@mui/styles';
// import { BOTTOM_NAV_HEIGHT } from 'layouts/Main/components/Sidebar/constants';
// import { ITheme } from 'theme/types';

// const useSidebarStyles = makeStyles((theme: ITheme) =>
//   createStyles({
//     drawer: {
//       position: 'relative',
//       zIndex: 1200,
//       [theme.breakpoints.up('lg')]: {},
//     },
//     drawerContainer: {
//       display: 'flex',
//       flexDirection: 'column',
//       height: '100%',
//       padding: 0,
//       position: 'relative',
//     },
//     drawerTop: {},
//     drawerBottom: {
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'space-between',
//       flexGrow: 1,
//     },
//     logo: {
//       display: 'flex',
//       minHeight: `${theme.toolbarHeight}px`,
//       alignItems: 'center',
//       justifyContent: 'center',
//     },
//     bottom: {
//       background: `linear-gradient(0deg, ${theme.palette.primary.dark} -50%, ${theme.palette.primary.main} 100%)`,
//       zIndex: 1000,
//       maxHeight: BOTTOM_NAV_HEIGHT,
//     },
//     drawerOpen: {
//       width: (props: { width: number }) => props.width,
//       transition: theme.transitions.create('width', {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.enteringScreen,
//       }),
//     },
//     drawerClose: {
//       width: (props: { width: number }) => props.width,
//       transition: theme.transitions.create('width', {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.leavingScreen / 2,
//       }),
//       overflowX: 'hidden',
//       [theme.breakpoints.up('sm')]: {
//         width: (props: { width: number }) => props.width,
//       },
//     },
//     toggleButton: {
//       position: 'fixed',
//       bottom: '20px',
//       left: '10px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       color: 'white',
//       backgroundColor: 'transparent',
//       border: 'none',
//       cursor: 'pointer',
//       width: '40px',
//       height: '40px',
//     },
//     buttonReset: {
//       background: 'none',
//       border: 'none',
//       padding: 0,
//       margin: 0,
//       font: 'inherit',
//       textAlign: 'inherit',
//       width: '100%',
//     },
//   })
// );

// export default useSidebarStyles;
